var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveInside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 302,
    viewBox: "0 0 1440 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H60C120 0 240 0 360 28C480 57 600 115 720 144C840 172 960 172 1080 151C1200 129 1320 86 1380 64L1440 43V302H1380C1320 302 1200 302 1080 302C960 302 840 302 720 302C600 302 480 302 360 302C240 302 120 302 60 302H0V0Z",
    fill: "#3C73FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveInside);
export default __webpack_public_path__ + "static/media/WaveInside.6689fa0b123ee22d4426a78afdae93e6.svg";
export { ForwardRef as ReactComponent };